






















































































































// :page="productsPage"
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
// @ts-ignore
import ProductDetailModal from '../modals/ProductDetailModal.vue';
import ProdelecPostModal from '../modals/ProdelecPostModal.vue';

import _ from 'lodash';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'web-inventory',
    data: function () {
        return {
            productsPageTest: 1,
        };
    },
    components: {
        ProductDetailModal,
        ProdelecPostModal,
        Spinner,
    },
    computed: {
        ...mapState('brand', ['allBrands']),
        ...mapState('brand', {
            allBrands: (state: any) => {
                return state.allBrands.map((brand: any) => {
                    return {
                        ...brand,
                    };
                });
            },
        }),
        ...mapState('category', ['allCategories']),
        ...mapState('category', {
            allCategories: (state: any) => {
                return state.allCategories.map((category: any) => {
                    return {
                        ...category,
                    };
                });
            },
        }),
        ...mapState('auth', ['currentUser']),
        ...mapState('webInventory', [
            'allProducts',
            'activeProduct',
            'activeProductloading',
            'allProductsLoading',
            'productsPerPage',
            'productsPage',
            'productsTotal',
        ]),
        ...mapState('webInventory', {
            allProducts: (state: any) => {
                //console.log(state.allProducts);
                const allProducts = state.allProducts.map((product: any) => {
                    return {
                        ...product,
                    };
                });
                return allProducts;
            },
        }),
    },
    watch: {
        allBrands: {
            handler() {
                this.updateBrandOptions();
            },
            immediate: true,
        },
        allCategories: {
            handler() {
                this.updateCategoryOptions();
            },
            immediate: true,

        }
    },
})
export default class WebInventory extends Vue {
    private currentUser!: any;
    public allProducts!: any;
    public activeProduct!: any;
    public activeProductLoading!: any;
    public allProductsLoading!: any;
    public productsPerPage!: any;
    public productsPage!: any;
    public productsTotal!: any;
    public productsPageTest!: any;
    public client!: any;
    public brand_filter: any = 'all';
    public category_filter: any = 'all';
    public allBrands: any;
    public allCategories: any

    brand_Options: any = [
        { value: 'all', text: 'Marcas', disabled: true },
    ];

    category_Options: any = [
        { value: 'all', text: 'Categorías', disabled: true },
    ];

    allProductsHeaders = [
        { thClass: 'th', key: 'img', label: '' },
        { thClass: 'th', sortable: true, key: 'id', label: 'SKU' },
        { thClass: 'th', sortable: true, key: 'manufacturer_sku', label: 'Clave de Fabricante' },
        { thClass: 'th', key: 'descripcion1', label: 'Descripción' },
        { thClass: 'th', sortable: true, key: 'stock', label: 'Existencias' },
        { thClass: 'th', key: 'price', label: 'Precio' },
        { thClass: 'th', key: 'menu', label: '' },
    ];

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    setUrlPage(page: any) {
        // @ts-ignore
        this.$router
            .push({
                path: 'web-inventory',
                query: {
                    ...this.$route.query,
                    page,
                },
            })
            .catch((err) => {
                // console.log('');
            });
        this.productsPageTest = page;
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'web-inventory',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'DESC' : 'ASC',
            },
        });
    }

    onOpenProductDetailModal(id: string | null = null, product: any | {}) {
        let modal = '';
        if (!id) {
            modal = 'product-detail-modal';
        } else {
            if (product.is_combo) {
                modal = 'prodelec-post-modal';
            } else {
                modal = 'product-detail-modal';
            }
        }
        this.$store.dispatch('webInventory/getOne', id);
        setTimeout(() => {
            // @ts-ignore
            this.$bvModal.show(modal);
        }, 600);
    }

    onOpenComboDetailModal(id: string | null = null) {
        this.$store.dispatch('webInventory/getOne', id);
        setTimeout(() => {
            // @ts-ignore
            this.$bvModal.show('prodelec-post-modal');
        }, 600);
    }

    setUrlSearch(search: string) {
        // @ts-ignore
        search = search.trim();
        this.$router.push({
            path: 'web-inventory',
            query: {
                ...this.$route.query,
                search,
            },
        });
        this.setUrlPage(1);
    }

    clearFilters() {
        this.$router.push({
            path: 'web-inventory',
            query: {},
        });
        this.productsPageTest = 1;
        this.brand_filter = 'all';
        this.category_filter = 'all';
    }

    onFilterBrand(brand: string) {
        this.$router.push({
            path: 'web-inventory',
            query: {
                ...this.$route.query,
                brand
            },
        });
    }

    onFilterCategory(category: string) {
        this.$router.push({
            path: 'web-inventory',
            query: {
                ...this.$route.query,
                category
            },
        });
    }

    @Watch('$route')
    getAllProducts() {
        // @ts-ignore
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const sortName = this.$route.query.sortName || null;
        const sortValue = this.$route.query.sortValue || null;
        const brand = this.$route.query.brand || null;
        const category = this.$route.query.category || null;
        this.$store.dispatch('webInventory/getAll', {
            page,
            search,
            sortName,
            sortValue,
            brand,
            category
        });
    }

    updateBrandOptions() {
        if (this.allBrands && this.allBrands.length > 0) {
            this.brand_Options = [
                { value: 'all', text: 'Marcas', disabled: true },
                ...this.allBrands.map((brand: any) => ({
                    value: brand.id,
                    text: brand.name,
                }))
            ];
        }
    }
    updateCategoryOptions() {
        if (this.allCategories && this.allCategories.length > 0) {
            this.category_Options = [
                { value: 'all', text: 'Categorías', disabled: true },
                ...this.allCategories.map((category: any) => ({
                    value: category.id,
                    text: category.name,
                }))
            ];
        }
    }

    getAllBrands() {
        this.$store.dispatch('brand/getAll', { search: '', page: 1 });
    }

    getAllCategories() {
        this.$store.dispatch('category/getAll', { search: '', page: 1 });
    }


    created() {
        this.getAllBrands();
        this.getAllCategories();
    }

    mounted() {
        this.getAllProducts();
        this.activeProduct = this.allProducts[0];
        this.productsPageTest = 1;
    }
}
